<script>
  import voiceCase_json from "@public/assets_default/data/voiceCase.json"
  const chevron_right = "/assets_default/icons/chevron_right.svg"

  const voiceCase = voiceCase_json;
  const { limit = 10, enableShowMore = true } = $props();
  let displayCount = $state(limit);

  function showAllItems() {
    displayCount = voiceCase.length;
  }
  let itemsToShow = $derived(voiceCase.slice(0, displayCount));
  let showMoreButton = $derived(enableShowMore && voiceCase.length > displayCount);
</script>


<ul class="owd-card-wrap:vertical">
  {#each itemsToShow as item}
  <li class="owd-card owd-card:link bg-colors:primary-wh">
    <a href="/project/voice/{item.link}/">
      <img src="{item.keyvisual}" width="120" height="120" alt="ダミー">
        <div class="owd-card:link-textarea">
          {#if item.status === 'new'}
          <div class="owd-servicesticker owd-servicesticker:yellow spacing:bottom:8">
            <p class="owd-label owd-servicesticker-label">NEW</p>
          </div>
          {/if}
            <p class="owd-information spacing:bottom:12">{item.catagory}</p>
          <p class="owd-caption spacing:bottom:12"><strong>{@html item.title}</strong></p>
          <p class="owd-information">{item.days}</p>
        </div>
        <img class="owd-card-icon" src="{chevron_right}" alt="右矢印アイコン">
    </a>
  </li>
  {/each}
</ul>

{#if showMoreButton}
<div class="spacing:bottom:16 block:center">
  <button class="owd-text:02" on:click={showAllItems}>
    <strong><span class="owd-textlink">もっと見る</span></strong>
  </button>
</div>
{/if}


<style lang="scss">
button{
  background: none;
  border: none;
  margin-top: 40px;
}

</style>
